<!--
 * @Description: 
 * @Date: 2022-07-06 19:59:43
-->
<template>
  <div>
    <xrk-table
      :get-list-ajax="getListAjax"
      :request-now="true"
      :search-config="{
        searchColumns
      }"
      :table-config="{
        baseConfig: { height: '43vh' },
        tableColumns
      }"
      ref="tableRenderRef"
    ></xrk-table>
  </div>
</template>

<script lang="tsx" setup>
import { XrkTable, useInputColumn, BaseTableColumnProps } from 'xrk-components';

import { terminalpList } from '@/views/industry-terminal-pay/src/data-source/apis';
import { date, money } from 'xrk-tools';

const props = defineProps({
  param: {
    type: Object,
    default: () => {
      return {
        orderType: 1,
        orderId: 0,
        projectId: 0
      };
    }
  }
});
async function getListAjax(params) {
  console.log(props.param);
  const data = await terminalpList({ ...params, ...props.param });
  return data;
}
const tableColumns: Array<BaseTableColumnProps> = [
  {
    label: '序号',
    type: 'index'
  },
  {
    label: '项目参与人',
    prop: 'fullName'
  },
  {
    label: '手机号',
    prop: 'phone'
  },
  {
    label: '收款方式',
    prop: 'collectMoneyType',
    render({ row }) {
      return <span>{['银行卡', '钱包'][row.collectMoneyType - 1]}</span>;
    }
  },
  {
    label: '结算时间',
    prop: 'finishPayDt',
    formatter: ({ cellValue }) => date.dateFormat(cellValue) || '-'
  },
  {
    label: '实际完成任务量',
    prop: 'finishSum'
  },
  {
    label: '终端结算单价',
    prop: 'taskPrice',
    formatter: ({ cellValue, row }) =>
      row.projectType == 19 ? '-' : money.moneyFixed(cellValue)
  },
  {
    label: '终端结算金额',
    prop: 'taskPriceSum',
    formatter: ({ cellValue }) => money.moneyFixed(cellValue || 0)
  },
  {
    prop: 'payStatus',
    label: '支付状态',
    render() {
      return <span>支付成功</span>;
    }
  }
];
const searchColumns = [
  useInputColumn({
    prop: 'fullName',
    label: '项目参与人',
    config: {
      placeholder: '请输入项目参与人'
    }
  }),
  useInputColumn({
    prop: 'phone',
    label: '手机号',

    config: {
      maxlength: 11,
      placeholder: '请输入手机号',
      inputRewrite: val => {
        val = '' + val;
        return val.replace(/[^\d]/g, '');
      }
    }
  })
];
</script>

<style lang="scss" scoped>
:deep {
  ._base-dialog .xrk-dialog__body {
    overflow-y: unset !important;
  }
  .xrk-table__body-wrapper {
    height: 30vh;
    overflow-y: auto;
  }
}
</style>
